import React from 'react';
import './BillingIdConfirmModal.css';

const BillingIdConfirmModal = ({ 
  isOpen, 
  onConfirm, 
  onCancel, 
  maxBillingId, 
  otherBillingIds 
}) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay billing-id-confirm-overlay">
      <div className="billing-id-confirm-modal">
        <div className="modal-header">
          <h3>
            <span className="warning-icon">⚠️</span>
            Multiple Billing IDs Detected
          </h3>
        </div>
        <div className="modal-body">
          <p className="info-text">
            The maximum billing ID <strong className="highlight-id">{maxBillingId}</strong> will be mapped to the new bill.
          </p>
          
          <p className="removed-ids-label">
            The following billing ID(s) will be removed:
          </p>
          
          <ul className="removed-ids-list">
            {otherBillingIds.map((id, index) => (
              <li key={index} className="removed-id-item">
                <span className="bullet">•</span>
                <strong>{id}</strong>
              </li>
            ))}
          </ul>
          
          <p className="confirmation-text">
            Are you sure you want to proceed?
          </p>
        </div>
        <div className="modal-actions">
          <button 
            className="modal-btn confirm-btn" 
            onClick={onConfirm}
          >
            Yes, Proceed
          </button>
          <button 
            className="modal-btn cancel-btn" 
            onClick={onCancel}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default BillingIdConfirmModal;